"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var react_redux_1 = require("react-redux");
var KeyInsightsOverview_1 = __importDefault(require("components/KeyInsights/KeyInsightsOverview"));
var OptimiseOverviewStats_1 = __importDefault(require("components/Optimise/OptimiseStats/OptimiseOverviewStats"));
var OnboardingLayout_1 = __importDefault(require("containers/Onboarding/OnboardingLayout"));
var selectors_1 = require("containers/Onboarding/selectors");
var Notifications_1 = __importDefault(require("./Notifications"));
var DashboardOverview = function (_a) {
    var serviceStatWithService = _a.serviceStatWithService;
    var _b = (0, react_redux_1.useSelector)(selectors_1.selectOnboardingProgress), totalSteps = _b.totalSteps, stepsDone = _b.stepsDone;
    return ((0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ md: 8 }, { children: [serviceStatWithService && (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ mt: 10 }, { children: (0, jsx_runtime_1.jsx)(KeyInsightsOverview_1.default, { serviceStatWithService: serviceStatWithService }) })), stepsDone !== totalSteps && (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, mt: 10, ml: -2 }, { children: (0, jsx_runtime_1.jsx)(OnboardingLayout_1.default, {}) })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ mt: serviceStatWithService || stepsDone !== totalSteps ? 7.5 : 10 }, { children: (0, jsx_runtime_1.jsx)(OptimiseOverviewStats_1.default, {}) }))] })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ md: 4 }, { children: (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ position: "relative", height: "100%", ml: 10, mt: 7 }, { children: (0, jsx_runtime_1.jsx)(Notifications_1.default, {}) })) }))] })));
};
exports.default = DashboardOverview;
